import {
  Pagination as PaginationBase,
  type PaginationProps,
} from '@shared/ui-components/pagination/pagination';

import { useGlobalCmsContentContext } from '../providers/global-cms-context';

export const Pagination = ({ ...rest }: PaginationProps) => {
  const { cmsContent } = useGlobalCmsContentContext();

  return (
    <PaginationBase
      {...rest}
      label={{
        nextPage: cmsContent.nextPage,
        pagination: cmsContent.pagination,
        previousPage: cmsContent.previousPage,
        totalItemsCount: cmsContent.totalItemsCount,
      }}
    />
  );
};
